import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "notifications",
  "use": "notifications-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"notifications\"><path fill-rule=\"evenodd\" d=\"M14 20.5h-4a2 2 0 1 0 4 0Zm4-9c0-3.07-1.64-5.64-4.5-6.32V4.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.86 6 8.42 6 11.5v5l-2 2v1h16v-1l-2-2v-5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol